/** Discriminated result type used for validation of user-supplied input. */
export type Result<T, E> =
  { readonly ok: true; readonly value: T } | { readonly ok: false; readonly error: E };

export const ok = <T>(value: T): { readonly ok: true; readonly value: T } => ({ ok: true, value });
export const err = <E>(error: E): { readonly ok: false; readonly error: E } => ({
  ok: false,
  error,
});

/**
 * Thrown for programmer errors (violated invariants), never for bad user input.
 * User input problems are reported through `Result` values instead.
 */
export class CoreError extends Error {
  readonly code: string;

  constructor(code: string, message: string) {
    super(message);
    this.name = 'CoreError';
    this.code = code;
  }
}
